<template>

  <div class="app-right-main">
    <div class="app-right-top-header">

      <div class="vertical-center header-content">

        <el-button type="primary" @click="addApp" class="add-button">
          添加App
        </el-button>

        <el-button type="primary" @click="addVersion" class="add-button">
          添加版本
        </el-button>
      </div>

    </div>

    <div class="app-right-table-content">
      <el-table
        :data="appList"
        stripe
        style="width: 100%">

        <el-table-column  align="center" v-for="item in this.projectConfig.APP_LIST_HEADER" :prop="item.prop" :label="item.label"
                         :key="item.prop">

        </el-table-column>

        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.native.prevent="addVersionForApp(scope.$index, appList)">添加版本
            </el-button>

            <el-button type="text" size="small" @click.native.prevent="showVersionsForApp(scope.$index, appList)">
              查看版本
            </el-button>

            <el-button type="text" size="small" @click.native.prevent="editApp(scope.$index, appList)">编辑
            </el-button>
            <el-button type="text" size="small" @click.native.prevent="deleteApp(scope.$index, appList)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>

  </div>

</template>

<script>
  export default {
    name: 'AppPackage'
  }
</script>

<style scoped>

</style>
